var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFilm = function SvgFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0h-16A2.503 2.503 0 0 0 0 2.5v14A2.503 2.503 0 0 0 2.5 19h16a2.503 2.503 0 0 0 2.5-2.5v-14A2.503 2.503 0 0 0 18.5 0zM5 18H2.5A1.5 1.5 0 0 1 1 16.5V13h4v5zm0-8.5V12H1V7h4v2.5zM5 6H1V2.5A1.5 1.5 0 0 1 2.5 1H5v5zm10 12H6v-8h9v8zm0-9H6V1h9v8zm5 7.5a1.5 1.5 0 0 1-1.5 1.5H16v-5h4v3.5zm0-4.5h-4V7h4v5zm0-6h-4V1h2.5A1.5 1.5 0 0 1 20 2.5V6z"
  })));
};

export default SvgFilm;